<!-- Detail -->
<div class="list-detail-container" *ngIf="!isLoading && list">

  <!-- Hero -->
  <div class="list-hero"
    [class.has-image]="list.icon"
    [style.background-image]="list.icon ? 'url(' + list.icon + ')' : 'none'">
    <div class="list-hero-overlay" *ngIf="list.icon"></div>

    <div class="list-hero-content">
      <!-- Volver -->
      <button class="back-btn" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        Volver
      </button>

      <!-- Título + badge + share -->
      <div class="hero-title-row">
        <h1 class="list-title">{{ list.name }}</h1>
        <span class="list-type-badge">{{ listTypeLabel }}</span>
        <div class="hero-actions">
          <button class="hero-icon-btn" (click)="shareList()" [title]="copied ? '¡Copiado!' : 'Compartir'">
            <svg *ngIf="!copied" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
            <svg *ngIf="copied" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
          <span class="copied-toast" *ngIf="copied">¡Copiado!</span>
        </div>
      </div>

      <!-- Owner -->
      <div class="list-owner" *ngIf="list.ownerInfo?.name">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        {{ list.ownerInfo!.name }}
        <img *ngIf="list.ownerInfo!.verified" src="/assets/verified.png" class="verified-icon" />
      </div>

      <!-- Stats -->
      <div class="list-stats">
        <div class="stat" *ngIf="list.size !== undefined">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
          {{ list.size }} bares
        </div>
        <div class="stat" *ngIf="list.followers !== undefined">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          {{ list.followers }} seguidores
        </div>
        <div class="stat" *ngIf="lastUpdateDate">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          Actualizada el {{ lastUpdateDate }}
        </div>

      </div>
    </div>
  </div>

  <!-- Bares de la lista -->
  <div class="list-content">
    <div class="content-inner">

      <div *ngIf="allBars.length > 0">
        <!-- Toolbar: buscar + ordenar -->
        <div class="bars-toolbar">
          <div class="search-input-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="search-icon">
              <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              class="search-input"
              placeholder="Buscar en esta lista..."
              [(ngModel)]="searchTerm" />
            <button *ngIf="searchTerm" class="clear-btn" (click)="clearSearch()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <div class="sort-btns">
            <button class="sort-btn" [class.active]="order === 'alphabetically'" (click)="setOrder('alphabetically')">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="3" y1="6" x2="15" y2="6"></line><line x1="3" y1="12" x2="9" y2="12"></line>
                <polyline points="12 15 15 18 18 15"></polyline><line x1="15" y1="9" x2="15" y2="18"></line>
              </svg>
              A–Z
            </button>
            <button class="sort-btn" [class.active]="order === 'recent'" (click)="setOrder('recent')">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              Recientes
            </button>
          </div>
        </div>

        <!-- Grid -->
        <div class="bars-grid" *ngIf="filteredBars.length > 0">
          <app-bar-entry
            *ngFor="let bar of filteredBars"
            [bar]="bar"
            (seeDetail)="onBarSelected($event)">
          </app-bar-entry>
        </div>

        <!-- Sin resultados de búsqueda -->
        <div class="empty-bars" *ngIf="filteredBars.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <p>No hay bares que coincidan con "{{ searchTerm }}"</p>
          <button class="clear-search-link" (click)="clearSearch()">Limpiar búsqueda</button>
        </div>
      </div>

      <!-- Lista vacía -->
      <div class="empty-bars" *ngIf="allBars.length === 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
        <p>Esta lista no tiene bares todavía</p>
      </div>

    </div>
  </div>
</div>

<!-- Loading -->
<div class="loading-container" *ngIf="isLoading">
  <div class="spinner"></div>
  <p>Cargando lista...</p>
</div>

<!-- Error -->
<div class="error-container" *ngIf="!isLoading && !list">
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
  <h2>Lista no encontrada</h2>
  <p>No pudimos cargar la información de esta lista.</p>
  <button class="back-btn-error" (click)="goBack()">Volver a búsqueda</button>
</div>
